import NetInfo from "@react-native-community/netinfo";
import { DefaultTheme, NavigationContainer } from "@react-navigation/native";
import { extendTheme, NativeBaseProvider } from "native-base";
import * as React from "react";
import { useState } from "react";
// Redux
import { useDispatch, useSelector } from "react-redux";
// import linking from "./LinkingConfig";
// import { CIP_BRAND } from "@env";
import { getTheme } from "../config/themes/theme";
import { setAuth } from "../redux/slices/LoginSlice";
import { getNavLinks } from "../redux/slices/NavMenuSlice";
import { getSetting } from "../redux/slices/settingSlice";
import { getStyle } from "../redux/slices/StyleSlice";
import NoConfigScreen from "../screens/NoConfigScreen/NoConfigScreen";
import OfflineScreen from "../screens/OfflineScreen/OfflineScreen";
import AppConstants from "../utils/Constants";
// Utils
import { getWithExpiry } from "../utils/LocalStorageManipulation";
import { isWeb } from "../utils/utils";
import MemberPages from "./MemberNavigator";
import PublicPages from "./PublicNavigator";

const BRAND_URL = isWeb()
	? AppConstants.WindowHostname
	: AppConstants.CIP_BRAND;

let is_connected = true;

export const Navigation = ({ colorScheme }) => {
	const [IsConnected, setIsConnected] = useState(true);
	const dispatch = useDispatch();

	NetInfo.addEventListener((state) => {
		if (!state.isConnected && is_connected) {
			setIsConnected(false);
		} else if (state.isConnected && !is_connected) {
			setIsConnected(true);
		}
		is_connected = state.isConnected;
	});

	React.useEffect(() => {
		getCredentials();
		dispatch(getStyle());
		dispatch(getNavLinks());
		dispatch(getSetting());
	}, []);

	const getCredentials = async () => {
		// const user = await AsyncStorage.getItem("auth");
		const user = await getWithExpiry("auth");

		if (user) {
			dispatch(setAuth(JSON.parse(user)));
		}
	};

	const isLoggedIn = useSelector((state) => state.Login.IsLoggedIn);
	const StyleConfig = useSelector((state) => state.config.Style);
	const NavLinks = useSelector((state) => state.Nav.NavLinks);

	const AppTheme = {
		colors: { ...DefaultTheme, ...getTheme(BRAND_URL) },
	};

	const theme = extendTheme(StyleConfig);

	/**
	 * =======================================================
	 * CHECK IF CONFIG IS CORRECT
	 * =======================================================
	 */
	if (isWeb()) {
		let URLs = Object.assign({}, AppConstants);

		delete URLs.WindowHostname;

		let exists = Object.keys(URLs).filter(
			(Key) => URLs[Key] == AppConstants.WindowHostname
		);

		if (exists.length < 1) {
			return (
				<NavigationContainer theme={AppTheme}>
					<NativeBaseProvider theme={theme}>
						<NoConfigScreen />
					</NativeBaseProvider>
				</NavigationContainer>
			);
		}
	}
	/**
	 * =======================================================
	 */

	return (
		<NavigationContainer theme={AppTheme}>
			<NativeBaseProvider theme={theme}>
				{NavLinks?.data?.length <= 0 || !is_connected ? (
					<OfflineScreen />
				) : isLoggedIn ? (
					<MemberPages />
				) : (
					<PublicPages />
				)}
			</NativeBaseProvider>
		</NavigationContainer>
	);
};
